import { IAffectedOrder, ICoverageGap } from "../interfaces/coverage";

export const coverageGapsToCsv = (gaps: ICoverageGap[]): string => {
  const header = "type,origin,destination_from,destination_to,weight_from,weight_to";
  const rows = gaps.map((gap) =>
    [gap.type, gap.origin, gap.destinationFrom, gap.destinationTo, gap.weightFrom ?? "", gap.weightTo ?? ""].join(",")
  );
  return [header, ...rows].join("\n");
};

export const affectedOrdersToCsv = (orders: IAffectedOrder[]): string => {
  const header = "external_id,tracking_id";
  const rows = orders.map((order) => [order.external_id, order.tracking_id].join(","));
  return [header, ...rows].join("\n");
};

export const downloadCsv = (filename: string, csvContent: string): void => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
